{
  "title": "Regenerate",
  "source": "Player's Handbook",
  "levelAndSchool": "7th-level transmutation",
  "level": 7,
  "castingTime": "1 minute",
  "range": "Touch",
  "components": "V, S, M (a prayer wheel and holy water)",
  "duration": "1 hour",
  "description": [
    "You touch a creature and stimulate its natural healing ability. The target regains 4d8 + 15 hit points. For the duration of the spell, the target regains 1 hit point at the start of each of its turns (10 hit points each minute).",
    "The target’s severed body members (fingers, legs, tails, and so on), if any, are restored after 2 minutes. If you have the severed part and hold it to the stump, the spell instantaneously causes the limb to knit to the stump."
  ],
  "spellLists": ["bard", "cleric", "druid"]
}
